import { useGlobalSearch } from "@/src/contexts/GlobalSearchContext"
import Skeleton from "@/src/sb/components/Skeleton"
import EnterNavigationArrowIcon from "@/src/sb/components/icon/EnterNavigationArrowIcon"
import NavigateKeyboardIcon from "@/src/sb/components/icon/NavigateKeyboardIcon"
import { USE_SEMANTIC_SEARCH_QUERY_PARAM } from "@/src/sb/constants"
import { SHOW_VIEW_ALL_SEARCH_RESULTS } from "@/src/sb/constants/featureFlags"
import { useFeatureValue } from "@growthbook/growthbook-react"
import { useRouter } from "next/router"
import React, { Fragment, useCallback } from "react"

type FooterType = {
  closeSearch?: () => void
  loading?: boolean
  searchResults?: {
    hasSearchData?: boolean
    searchQuery?: string
    isSemanticSearch?: boolean
  }
}

const Footer = ({ closeSearch, loading, searchResults }: FooterType) => {
  const router = useRouter()
  const { setLastVisitedUrl } = useGlobalSearch()

  const handleNavigateWithSearchResult = useCallback(() => {
    if (searchResults?.searchQuery) {
      let fullPath = `/search?q=${searchResults.searchQuery}`
      if (searchResults.isSemanticSearch !== undefined) {
        fullPath += `&${USE_SEMANTIC_SEARCH_QUERY_PARAM}=${searchResults.isSemanticSearch}`
      }

      router.push(fullPath)
      setLastVisitedUrl(fullPath)
    }
  }, [searchResults?.searchQuery, router])

  const SHOW_VIEW_SEARCH_RESULTS = useFeatureValue(
    SHOW_VIEW_ALL_SEARCH_RESULTS,
    false
  )

  return (
    <footer className="flex justify-between text-gray-400 border-t-[0.5px] border-[#4B5563] items-center">
      <span
        className={
          "px-5 py-2.5 flex flex-row gap-2 items-center text-[#9CA3AF]"
        }
      >
        {loading ? (
          <Skeleton width={40} height={20} />
        ) : (
          <div
            onClick={closeSearch}
            className="flex flex-row gap-2 items-center"
          >
            {(!searchResults?.hasSearchData || !SHOW_VIEW_SEARCH_RESULTS) && (
              <span className="bg-[#1F2937] p-1 rounded-[2px] border-[0.5px] border-[#4B5563] !text-[#9CA3AF] font-normal text-[11px]">
                Esc
              </span>
            )}

            {(!searchResults?.hasSearchData || !SHOW_VIEW_SEARCH_RESULTS) && (
              <p className="text-[10px]">to cancel</p>
            )}

            {searchResults?.hasSearchData && SHOW_VIEW_SEARCH_RESULTS && (
              <p
                className={
                  "text-[#85BEEF] normal-case text-[10px] cursor-pointer"
                }
                onClick={handleNavigateWithSearchResult}
              >
                View all search results
              </p>
            )}
          </div>
        )}
      </span>
      <div className="md:block hidden">
        <div className="flex flex-row items-center">
          <div className="flex flex-row gap-1.5 py-2 items-center">
            {loading ? (
              <Skeleton width={40} height={20} />
            ) : (
              <Fragment>
                <span className="bg-[#1F2937] cursor-text px-1 py-1 rounded-[2px] flex items-center justify-center  border-[0.5px] border-[#4B5563]">
                  <NavigateKeyboardIcon />
                </span>
                <span className="bg-[#1F2937] cursor-text px-1 py-1 rounded-[2px] flex items-center justify-center rotate-180 border-[0.5px] border-[#4B5563]">
                  <NavigateKeyboardIcon />
                </span>
                <p className="text-[#9CA3AF] text-[10px]">to navigate</p>
              </Fragment>
            )}
          </div>

          <div className="flex flex-row gap-1.5 px-4 py-2 items-center">
            {loading ? (
              <Skeleton width={40} height={20} />
            ) : (
              <Fragment>
                <span
                  className="bg-[#1F2937] px-1 py-1 cursor-text
 rounded-[2px] flex items-center justify-center border-[0.5px] border-[#4B5563]"
                >
                  <EnterNavigationArrowIcon />
                </span>
                <p className="text-[#9CA3AF] text-[10px]">to select</p>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
